(function () {
  'use strict';
  const angular = window.angular;
  EmbeddedContainerController.$inject = ['$scope', '$element', '$timeout', '$state', 'AppUtils', '$rootScope', 'LoopBackAuth', '$sce'];
  angular.module('app').component('embeddedContainer', {
    template:'<div class="panel panel-default" ng-if="!ctrl.hideHeader"><header class="panel-heading text-center"><h2><strong>{{ctrl.options.name}}</strong></h2><div class="panel-toolbars pull-right"><div class="panel-toolbar"><div class="btn-group" uib-dropdown><button ng-disabled="ctrl.loading" class="btn btn-xs btn-primary" uib-dropdown-toggle><span class="fas fa-cog"></span> <span translate>general.actions</span> <span class="caret"></span></button><ul class="dropdown-menu dropdown-menu-right" uib-dropdown-menu><li><a href="#" ng-click="ctrl.reload()"><span><i class="fas fa-sync marginR5"></i> <span translate>buttons.reload</span></span></a></li><li><a href="#" ng-click="ctrl.showReportForm()"><span><i class="fas fa-edit marginR5"></i> <span translate>buttons.edit</span></span></a></li><li class="divider"></li><li><a href="#" class="text-danger" ng-click="ctrl.removeReport()"><span class="text-danger"><i class="fas fa-trash marginR5"></i> <span translate>buttons.delete</span></span></a></li></ul></div></div></div></header><div class="panel-body"><iframe class="embedded-frame" style="width: 100%; height: 100%; margin: auto" ng-src="{{ctrl.options.trustSrc}}" frameborder="0" allowfullscreen></iframe><spinner show="ctrl.loading" css-class="\'body-bg small\'" show-logo="true"></spinner><div ng-if="ctrl.error" class="alert alert-danger" style="position: absolute; top: 10px; left: 10px; right: 10px">{{ctrl.error}} <button type="button" class="btn btn-default btn-sm" ng-click="ctrl.reload()"><span translate>buttons.reload</span></button></div></div></div><div ng-if="ctrl.hideHeader" class="absolute"><iframe class="embedded-frame" allow="clipboard-write; fullscreen" style="width: 100%; height: 100%; margin: auto" ng-src="{{ctrl.options.trustSrc}}" frameborder="0" allowfullscreen></iframe><spinner show="ctrl.loading" css-class="\'body-bg small\'" show-logo="true"></spinner><div ng-if="ctrl.error" class="alert alert-danger" style="position: absolute; top: 10px; left: 10px; right: 10px">{{ctrl.error}} <button type="button" class="btn btn-default btn-sm" ng-click="ctrl.reload()"><span translate>buttons.reload</span></button></div></div>',
    controller: EmbeddedContainerController,
    controllerAs: 'ctrl',
    bindings: { options: '<', removeReport: '&', showReportForm: '&', hideHeader: '<', waitForReadyMessage: '<', onMessage: '&' },
  });
  function EmbeddedContainerController($scope, element, $timeout, $state, utils, $rootScope, LoopBackAuth, $sce) {
    // Each mounted report owns its iframe, channel and timers.
    const vm = this;
    let initTimer;
    let setupTimer;
    let loadingTimer;
    let destroyed = false;
    let ready = false;
    let targetOrigin;
    vm.$onInit = function () {
      vm.loading = true;
      vm.childId = utils.generateUUID();
      vm.projectRoot = $state.get().find(state => state.projectRoot === true);
      try {
        const src = $sce.getTrustedResourceUrl(vm.options.trustSrc);
        const url = new URL(src, window.location.href);
        if (!['http:', 'https:'].includes(url.protocol)) return;
        targetOrigin = url.origin;
      } catch { return; }
      window.addEventListener('message', onMessage);
      vm.offPostMessage = $scope.$on('postMessage', (_event, message) => postMessage(message));
      setupTimer = $timeout(() => {
        if (destroyed) return;
        vm.embeddedFrame = element.find('.embedded-frame');
        vm.embeddedFrame.on('load', onFrameLoad);
        startHandshake();
      }, 0);
    };
    function finishLoading() {
      $timeout.cancel(loadingTimer);
      if (!vm.waitForReadyMessage) window.clearInterval(initTimer);
      vm.error = null;
      vm.options.loaded = true;
      vm.loading = false;
    }
    function onFrameLoad() {
      vm.options.loaded = true;
      startHandshake();
      if (!vm.waitForReadyMessage) finishLoading();
    }
    function startHandshake() {
      vm.error = null;
      vm.loading = true;
      $timeout.cancel(loadingTimer);
      loadingTimer = $timeout(() => {
        if (!vm.waitForReadyMessage) return finishLoading();
        vm.loading = false;
        vm.error = $rootScope.currentLang === 'es'
          ? 'No se pudo cargar la aplicación. Intenta recargarla.'
          : 'The application could not be loaded. Reload to try again.';
        window.clearInterval(initTimer);
      }, vm.waitForReadyMessage ? 20000 : 2000);
      ready = false;
      window.clearInterval(initTimer);
      postMessage({ type: 'HOST_INIT', payload: { id: vm.childId } });
      initTimer = window.setInterval(() => {
        if (!ready) postMessage({ type: 'HOST_INIT', payload: { id: vm.childId } });
      }, 1000);
    }
    vm.$onDestroy = function () {
      destroyed = true;
      $timeout.cancel(setupTimer);
      $timeout.cancel(loadingTimer);
      window.clearInterval(initTimer);
      if (vm.offPostMessage) vm.offPostMessage();
      if (vm.embeddedFrame) vm.embeddedFrame.off('load', onFrameLoad);
      window.removeEventListener('message', onMessage);
    };
    vm.reload = function () {
      if (vm.embeddedFrame?.length) vm.embeddedFrame[0].src = vm.embeddedFrame[0].src;
    };
    function postMessage(message) {
      if (destroyed || !targetOrigin || !vm.embeddedFrame?.length) return;
      vm.embeddedFrame[0].contentWindow.postMessage({ ...message, source: vm.childId }, targetOrigin);
    }
    function bootstrap() {
      const user = $rootScope.user;
      if (!user?.id || !LoopBackAuth.accessTokenId) return;
      postMessage({ type: 'HOST_BOOTSTRAP', payload: {
        token: LoopBackAuth.accessTokenId,
        userId: user.id,
        userType: user.isSuperAdmin ? 'SuperAdmin' : user.isSupportAdmin ? 'SupportAdmin' : user.isAdmin ? 'Admin' : 'Manager',
        varId: $rootScope.varId || undefined,
        language: $rootScope.currentLang,
        lang: $rootScope.currentLang,
        theme: $rootScope.darkMode ? 'dark' : 'light',
        application: vm.options.application,
      } });
    }
    function onMessage(event) {
      if (destroyed || !vm.embeddedFrame?.length || event.source !== vm.embeddedFrame[0].contentWindow || event.origin !== targetOrigin) return;
      const data = event.data;
      if (!data || typeof data !== 'object' || data.source !== vm.childId || typeof data.type !== 'string') return;
      const { type, payload } = data;
      $scope.$evalAsync(() => {
        if (destroyed) return;
        switch (type) {
          case 'CHILD_READY': bootstrap(); break;
          case 'AUTH_EXPIRED': bootstrap(); break;
          case 'APP_READY':
            ready = true;
            window.clearInterval(initTimer);
            finishLoading();
            break;
          case 'RELOAD': vm.reload(); break;
          case 'GO_TO': {
            if (!vm.projectRoot || !payload || typeof payload.state !== 'string' || !/^[\w.-]+$/.test(payload.state)) return;
            const state = vm.projectRoot.name + '.' + payload.state;
            if ($state.get(state)) $state.go(state, payload.params);
            break;
          }
        }
        vm.onMessage({ type, payload });
      });
    }
  }
})();
